import useDebounce from "@/common/hooks/useDebounce";
import { useCallback, useEffect } from "react";

interface useCardReaderProps {
  enabled: boolean;
  onRead: (cardData: string) => any
}

const useCardReader = ({ enabled, onRead }: useCardReaderProps) => {
  const [debouncedCardData, setDebouncedCardData, _, forceSetCardData] = useDebounce('');

  const readCardData = useCallback((event: KeyboardEvent) => {
    let char = event.key;

    if(char.length > 1) {
      if(char == 'Enter') char = '\n'
      else char = ''
    }

    setDebouncedCardData((prev) => prev + char)
  }, [])

  useEffect(() => {
    if(debouncedCardData) {
      onRead(debouncedCardData);
      forceSetCardData('');
    }
  }, [debouncedCardData])

  useEffect(() => {
    if (enabled) {
      window.removeEventListener('keydown', readCardData);
      window.addEventListener('keydown', readCardData, {});
    } else {
      window.removeEventListener('keydown', readCardData);
    }
  }, [enabled]);
};

export default useCardReader;
